import { render, staticRenderFns } from "./TextFormat.vue?vue&type=template&id=f5814072&scoped=true&"
import script from "./TextFormat.vue?vue&type=script&lang=ts&"
export * from "./TextFormat.vue?vue&type=script&lang=ts&"
import style0 from "./TextFormat.vue?vue&type=style&index=0&id=f5814072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5814072",
  null
  
)

export default component.exports